import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import blogsvg from "../../assets/images/etc/blog.svg";
import kakaosvg from "../../assets/images/etc/kakao.svg";
import youtubesvg from "../../assets/images/etc/youtube.svg";
import instagramsvg from "../../assets/images/etc/instagramsvg.svg";
import "./Footer.css";
import { DEFAULT_LANG } from "../../i18n";

const getLangFromPath = (pathname) => {
  const m = pathname.match(/^\/(kr|en)(\/|$)/);
  return m ? m[1] : DEFAULT_LANG;
};

function Footer() {
  const { t } = useTranslation();
  const lang = getLangFromPath(useLocation().pathname);

  return (
    <footer className="footer">
      <div className="flex justify-between">
        <div>
          <div className="footerRowa  ">
            <NavLink className="FontL textF12" to={`/${lang}/privacypolicy/healiary/0`}>
              {t("footer.privacy")}
            </NavLink>
            <span className="slash FontL textF12">/</span>
            <NavLink className="FontL textF12" to={`/${lang}/privacypolicy/healiary/1`}>
              {t("footer.terms")}
            </NavLink>
          </div>
          <div className="footerRow">
            <div className="footerContent FontL textF12">
              <span className="tco FontL textF12">{t("footer.addressLabel")}</span>
              {t("footer.address")}
            </div>
            <div className="footerContent FontL textF12">
              <span className="tco FontL textF12">{t("footer.emailLabel")}</span>
              herings@heringsglobal.com
            </div>
            <div className="footerContent FontL textF12">
              <span className="tco FontL textF12">{t("footer.registrationLabel")}</span>
              {t("footer.registration")}
            </div>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            columnGap: "24px",
          }}
        >
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://blog.naver.com/healiary"
          >
            <img src={blogsvg} alt="blog" className="footersvg" />
          </a>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://pf.kakao.com/_xlPYExj"
          >
            <img src={kakaosvg} alt="kakao" className="footersvg" />
          </a>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.youtube.com/@healiary"
          >
            <img src={youtubesvg} alt="youtube" className="footersvg" />
          </a>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.instagram.com/healiary_official/"
          >
            <img src={instagramsvg} alt="instagram" className="footersvg" />
          </a>
        </div>
      </div>
      <div className="footerRow FontL textF12">
        <div className="footerContent FontL textF12">
          {t("footer.copyright", { year: new Date().getFullYear() })}
        </div>
      </div>
    </footer>
  );
}

export default Footer;
